import { isUndefined as lo_isUndefined } from 'es-toolkit';
import type { Reactive } from 'vue';

type Source = MaybeRef<boolean> | Reactive<boolean>;

export function useIsLoading() {
    const tracked: Set<string> = reactive(new Set());
    const sources: Map<string, Source> = reactive(new Map());

    const hasTrackedKeys = computed(() => tracked.size > 0);
    const hasSourceLoading = computed(() =>
        Array.from(sources.values()).some((source) => Boolean(unref(source)))
    );

    const isLoading = computed<boolean>(() => hasTrackedKeys.value || hasSourceLoading.value);

    function on(key: string): void {
        tracked.add(key);
    }

    function off(key: string): void {
        tracked.delete(key);
    }

    function toggle(key: string, state?: boolean): void {
        lo_isUndefined(state) ?
            tracked[ tracked.has(key) ? 'delete' : 'add' ](key) :
            tracked[ state ? 'add' : 'delete' ](key);
    }

    function clear(): void {
        tracked.clear();
    }

    function addSource(key: string, source: Source): void {
        sources.set(key, source);
    }

    function removeSource(key: string): void {
        sources.delete(key);
    }

    function destroy(): void {
        tracked.clear();
        sources.clear();
    }

    return {
        isLoading,
        on,
        off,
        toggle,
        clear,
        addSource,
        removeSource,
        destroy,
        tracked: readonly(tracked),
        sources: readonly(sources)
    };
}
